import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import WebAgendamento from "../WebsiteAgendamento/WebAgendamento";
import LoginAgendamento from "../WebsiteAgendamento/LoginAgendamento";
import ConfirmAgendamento from "../WebsiteAgendamento/ConfirmAgendamento";
import SalonTemplate from "../WebsiteAgendamento/Templates/Salon/SalonTemplate";
import BarberTemplate from "../WebsiteAgendamento/Templates/BarberTemplate";
import StudioTemplate from "../WebsiteAgendamento/Templates/StudioTemplate";
import PetshopTemplate from "../WebsiteAgendamento/Templates/PetshopTemplate";
import BookingPage from "../WebsiteAgendamento/Templates/BookingPage";
import App from "../WebsiteAgendamento/siteTeste/App";
const WebsiteRoutes = () => {


    return (
        <BrowserRouter>
            <Routes>
                <Route path="/:dominio/template" element={<SalonTemplate />} />
                <Route path="/:dominio/sign_in" element={<LoginAgendamento />} />
                <Route path="/:dominio/login" element={<LoginAgendamento />} />

                <Route path="/:dominio/confirmAgendamento" element={<ConfirmAgendamento />} />
             <Route path="/:dominio/tempTeste" element={<App />} />
                <Route path="/:dominio" element={<WebAgendamento />} />

            </Routes>
        </BrowserRouter>

    )
}
export default WebsiteRoutes;